export * from './DealDetails'
